import { render } from "./CustomerInformation.vue?vue&type=template&id=5f59d180"
import script from "./CustomerInformation.vue?vue&type=script&lang=ts"
export * from "./CustomerInformation.vue?vue&type=script&lang=ts"
script.render = render

export default script